<ion-header class="ion-no-border" >
  <ion-toolbar *ngIf="title!=''">
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>

  <ion-toolbar style="padding-top:0">
    <form [formGroup]="searchForm" style="width: 100%"  class="ion-no-padding">
      <ion-searchbar
      #search
      type="search"
      animated="true"
      placeholder="Name, phone or email"
      formControlName="searchField"
      show-cancel-button="never"
      [(ngModel)]="searchTerm"
      (keyup)="onSearch($event)"
      autocomplete="off"
      >
    </ion-searchbar>
  </form>
</ion-toolbar>
</ion-header>

<ion-content class="smr-client-list">

  <ion-item *ngIf="isSearchingForClients" class="ion-no-padding">
    <ion-spinner icon="crescent"></ion-spinner>
    &nbsp;Searching for "{{ searchTerm }}" ...
  </ion-item>

  <ion-item
    *ngIf="errorOccurredWhileSearchingForClients"
    class="smr-error ion-no-padding"
  >
    Oops, an error occurred. Please try again.
  </ion-item>

  <ion-item
    class="ion-padding"
    *ngIf="
      !isSearchingForClients &&
      searchTerm.length > 2 &&
      searchTerm != '' &&
      clientSearchResult.count() == 0
    "
  >
  No clients found, please try a different search.
  </ion-item>

  <ng-container
    *ngIf="
      !isSearchingForClients &&
      searchTerm != '' &&
      clientSearchResult.count() > 0
    "
  >
    <smr-client-item
      *ngFor="let client of clientSearchResult; let clientIndex = index"
      [ngClass]="{
        'smr-client-selected':
          selectedClient && client.getID() == selectedClient.getID()
      }"
      [client]="client"
      (clientSelect)="onClientSelect($event, true, clientIndex)"
    >
    </smr-client-item>
  </ng-container>

  <ng-container
    *ngIf="!isSearchingForClients && searchTerm.length <= 2 && clientList.count() > 0"
  >
    <smr-client-item
      *ngFor="let client of clientList; let clientIndex = index"
      [ngClass]="{
        'smr-client-selected':
          selectedClient && client.getID() == selectedClient.getID()
      }"
      [client]="client"
      (clientSelect)="onClientSelect($event, true, clientIndex)"
    >
    </smr-client-item>
  </ng-container>

  <salonmonster-load-mask *ngIf="isLoadingClientList"></salonmonster-load-mask>

  <smr-tap-retry
    *ngIf="errorOccurredWhileLoadingClientList"
    (click)="loadClients()"
  ></smr-tap-retry>

  <ion-infinite-scroll
    (ionInfinite)="onInfiniteScroll($event)"
    [disabled]="clientListFullyLoaded"
  >
    <ion-infinite-scroll-content loadingText="Loading data..." loadingSpinner="bubbles"></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
